import React from "react";

function Icon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      clipRule="evenodd"
      viewBox="0 0 540 540"
      height={props.height ? props.height : "22px"}
    >
      <path
        fill={props.color ? props.color : "black"}
        d="M858.287 957.15l196.523 196.52a4.158 4.158 0 010 5.89l-36.23 36.23a4.158 4.158 0 01-5.89 0S775.752 958.861 747.085 930.193a4.001 4.001 0 010-5.657c28.667-28.668 265.605-265.601 265.605-265.601a4.164 4.164 0 015.89 0l36.23 36.23a4.16 4.16 0 010 5.892L858.287 897.579h422.763c2.3 0 4.16 1.866 4.16 4.167v51.237a4.162 4.162 0 01-4.16 4.167H858.287z"
        transform="translate(-745.913 -657.715)"
      ></path>
    </svg>
  );
}

export default Icon;
